import React, { useState } from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Music, BookOpen, Package, Shirt, Star, ArrowRight, Download, Play } from 'lucide-react';
import CorporateHeader from './CorporateHeader';
import Footer from './Footer';

const StorePage = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Assets', icon: ShoppingBag },
    { id: 'digital', name: 'Digital Assets', icon: Download },
    { id: 'books', name: 'Books', icon: BookOpen },
    { id: 'soundtrack', name: 'Soundtrack', icon: Music },
    { id: 'bundles', name: 'Bundles', icon: Package },
    { id: 'merchandise', name: 'Merchandise', icon: Shirt },
  ];

  const products = [
    // Digital Products - Full Bundle
    {
      id: 'author-ecosystem',
      name: 'The Ultimate Author Social Media eCoSystem',
      category: 'digital',
      price: 97,
      originalPrice: 174,
      image: 'https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/ir99bh6p_THE%20ULTIMATE%20AUTHOR%20INSTAGRAM%20eCoSystem%20front%20cover.png',
      description: 'FULL BUNDLE: Facebook, Instagram, TikTok guides + Author Resource Guide + FREE Case Study Blueprint.',
      badge: 'BEST VALUE',
      badgeColor: 'bg-green-600',
      path: '/author-ecosystem',
    },
    // Individual eCoSystem Products
    {
      id: 'facebook-ecosystem',
      name: 'Facebook eCoSystem Guide',
      category: 'digital',
      price: 27,
      image: 'https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/rnk6gz3y_THE%20Ultimate%20Authors%20FACEbook%20cover.png',
      description: 'Master Facebook marketing for authors. Grow your readership through strategic Facebook presence.',
      badge: null,
      path: '/author-ecosystem',
    },
    {
      id: 'instagram-ecosystem',
      name: 'Instagram eCoSystem Guide',
      category: 'digital',
      price: 27,
      image: 'https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/ir99bh6p_THE%20ULTIMATE%20AUTHOR%20INSTAGRAM%20eCoSystem%20front%20cover.png',
      description: 'Build your author brand on Instagram. Visual storytelling and engagement strategies.',
      badge: null,
      path: '/author-ecosystem',
    },
    {
      id: 'tiktok-ecosystem',
      name: 'TikTok eCoSystem Guide',
      category: 'digital',
      price: 27,
      image: 'https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/g4dpspzt_Ultimate%20Author%20TIKTOK%20eCoSystem%20front%20cover.png',
      description: 'Leverage BookTok to reach millions of readers. The fastest growing platform for book discovery.',
      badge: null,
      path: '/author-ecosystem',
    },
    {
      id: 'author-resource-guide',
      name: 'Author Resource Guide',
      category: 'digital',
      price: 27,
      image: 'https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/l3735rry_AUTHOR%20RESOURCE%20GUIDE%20-%20FINAL.png',
      description: 'Comprehensive resource guide packed with tools, templates, and strategies for author success.',
      badge: null,
      path: '/author-ecosystem',
    },
    {
      id: 'case-study-blueprint',
      name: 'Case Study Blueprint',
      category: 'digital',
      price: 19,
      image: 'https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/46y75gw2_FREE%20-%20HOW%20THE%20ULTIMATE%20AUTHOR%20eCoSystem%20creates%20BestSellers.png',
      description: 'Learn how the Ultimate Author eCoSystem creates bestsellers. FREE with full bundle purchase.',
      badge: 'FREE WITH BUNDLE',
      badgeColor: 'bg-yellow-600',
      path: '/author-ecosystem',
    },
    // Soundtrack
    {
      id: 'mindset-soundtrack',
      name: 'Mindset Shift - The Official Soundtrack',
      category: 'soundtrack',
      price: 9.99,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/ujuixs3p_MINDSET%20SHIFT%20Soundtrack%20Cover.png',
      description: '11 transformational R&B tracks + Bonus Lyric Sheet PDF included.',
      badge: 'NEW',
      badgeColor: 'bg-purple-600',
      path: '/mindset-shift-soundtrack',
      streamLink: 'https://distrokid.com/hyperfollow/egyptyoung/mindset-shift-the-official-soundtrack-2'
    },
    // Books
    {
      id: 'ava-and-maverick',
      name: 'The Adventures of Ava and Maverick Go To School',
      category: 'books',
      price: 9.99,
      image: 'https://customer-assets-agu9un31.emergentagent.net/job_714c4da9-c687-4be7-8ba1-ec382daddaca/artifacts/ab4749f59fe17a6f_A%26M%20Page%200.png',
      description: 'A joyful 36-page picture book for ages 7 & under. Instant PDF download.',
      badge: 'NEW',
      badgeColor: 'bg-pink-600',
      path: '/ava-and-maverick',
      comingSoon: false
    },
    {
      id: 'this-or-that-vol1',
      name: 'THIS OR THAT - Volume 1',
      category: 'books',
      price: 9.99,
      image: 'https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/dezhjave_1%20THIS%20or%20THAT%20How%20Well%20Do%20You%20Know%20Them%20Vol%201.%20cover.png',
      description: 'The ultimate conversation starter book. Digital download.',
      badge: null,
      path: '/store/this-or-that-vol1',
      comingSoon: false
    },
    {
      id: 'this-or-that-vol2',
      name: 'THIS OR THAT - Volume 2',
      category: 'books',
      price: 9.99,
      image: 'https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/rw6b567o_2%20THIS%20or%20THAT%20How%20Well%20Do%20You%20Know%20Your%20Partner%20Vol%202%20-%20cover.png',
      description: 'More engaging questions to spark meaningful conversations. Digital download.',
      badge: null,
      path: '/store/this-or-that-vol2',
      comingSoon: false
    },
    {
      id: 'this-or-that-vol3',
      name: 'THIS OR THAT - Volume 3',
      category: 'books',
      price: null,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/o60phml6_THIS%20or%20THAT%20Vol.%203.png',
      description: 'Continue the conversation with Volume 3.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      comingSoon: true
    },
    {
      id: 'this-or-that-vol4',
      name: 'THIS OR THAT - Volume 4',
      category: 'books',
      price: null,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/eohhys62_THIS%20or%20THAT%20Vol.%204%20-%20GameBook%20Series.png',
      description: 'GameBook Series edition.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      comingSoon: true
    },
    {
      id: 'this-or-that-vol5',
      name: 'THIS OR THAT - Volume 5',
      category: 'books',
      price: null,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/fd9cg33h_THIS%20or%20THAT%20Vol.%205%20-%20GUESS%20ALL%2010%20SLANG%20TWINS%20Vol.%205.png',
      description: 'Slang Twins edition.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      comingSoon: true
    },
    {
      id: 'mindset-shift-book',
      name: 'The Mindset Shift',
      category: 'books',
      price: null,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/pjhwtif3_THE%20MINDSET%20SHIFT%20-%20cover.png',
      description: 'Transform your thinking, transform your life. The book that started the movement.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      comingSoon: true
    },
    {
      id: 'true-companion-journal',
      name: 'True Companion Journal',
      category: 'books',
      price: null,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/fap9i5s3_MINDSET%20SHIFT%20TRUE%20COMPANION%20JOURNAL.png',
      description: 'Your personal growth companion for daily mindset shifts.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      comingSoon: true
    },
    {
      id: 'daily-affirmations',
      name: 'Book of Daily Affirmations',
      category: 'books',
      price: null,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/y4rkhenp_MINDSET%20SHIFT%20BOOK%20OF%20DAILY%20AFFIRMATIONS.png',
      description: 'Daily affirmations to reprogram your mindset.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      comingSoon: true
    },
    // Bundles
    {
      id: 'mindset-ecosystem-bundle',
      name: 'Mindset Shift Complete eCoSystem',
      category: 'bundles',
      price: 97,
      image: 'https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/ujuixs3p_MINDSET%20SHIFT%20Soundtrack%20Cover.png',
      description: 'Soundtrack + Book + Video Series + Corporate Licensing access.',
      badge: 'BEST VALUE',
      badgeColor: 'bg-yellow-600',
      path: '/mindset-shift-ecosystem',
      comingSoon: false
    },
    // Merchandise (Future)
    {
      id: 'mindset-apparel',
      name: 'Mindset Shift Apparel Collection',
      category: 'merchandise',
      price: null,
      image: null,
      icon: Shirt,
      description: 'Premium apparel featuring the Mindset Shift brand.',
      badge: 'COMING SOON',
      badgeColor: 'bg-gray-600',
      path: null,
      color: 'from-gray-600 to-gray-700',
      comingSoon: true
    },
  ];

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(p => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-black">
      <CorporateHeader />
      
      {/* Hero */}
      <section className="pt-28 pb-16 bg-gradient-to-b from-black via-gray-900 to-black">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-6xl font-black text-white mb-4">Strategic Digital Assets</h1>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Explore books, media toolkits, digital systems, and exclusive bundles engineered to elevate mindset, amplify authors, and accelerate brand growth.
          </p>
        </div>
      </section>

      {/* Categories */}
      <section className="py-8 bg-black border-b border-gray-800 sticky top-20 z-40">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => {
              const Icon = cat.icon;
              return (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all duration-200 ${
                    activeCategory === cat.id
                      ? 'bg-red-600 text-white'
                      : 'bg-gray-900 text-gray-400 hover:bg-gray-800 hover:text-white'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {cat.name}
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Assets Grid */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProducts.length === 0 ? (
            <div className="text-center py-20">
              <ShoppingBag className="w-16 h-16 text-gray-700 mx-auto mb-4" />
              <p className="text-gray-500 text-lg">No assets in this category yet.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProducts.map((product) => {
                const Icon = product.icon;
                return (
                  <div 
                    key={product.id}
                    className={`group bg-gray-900/50 border border-gray-800 rounded-2xl overflow-hidden hover:border-red-600/50 transition-all duration-300 ${
                      product.comingSoon ? 'opacity-75' : ''
                    }`}
                  >
                    {/* Image / Icon */}
                    <div className="relative aspect-square">
                      {product.image ? (
                        <img 
                          src={product.image} 
                          alt={product.name}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                      ) : (
                        <div className={`w-full h-full bg-gradient-to-br ${product.color || 'from-gray-700 to-gray-800'} flex items-center justify-center`}>
                          {Icon && <Icon className="w-24 h-24 text-white/30" />}
                        </div>
                      )}
                      
                      {/* Badge */}
                      {product.badge && (
                        <div className={`absolute top-4 left-4 ${product.badgeColor || 'bg-red-600'} text-white text-xs font-bold px-3 py-1 rounded-full`}>
                          {product.badge}
                        </div>
                      )}
                    </div>
                    
                    {/* Content */}
                    <div className="p-6">
                      <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-500 transition-colors">
                        {product.name}
                      </h3>
                      <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                        {product.description}
                      </p>
                      
                      {/* Price */}
                      <div className="flex items-center gap-3 mb-4">
                        {product.price ? (
                          <>
                            <span className="text-2xl font-bold text-white">${product.price}</span>
                            {product.originalPrice && (
                              <span className="text-gray-500 line-through">${product.originalPrice}</span>
                            )}
                          </>
                        ) : (
                          <span className="text-lg text-gray-500">Price TBD</span>
                        )}
                      </div>
                      
                      {/* Actions */}
                      <div className="flex gap-3">
                        {product.comingSoon ? (
                          <Button 
                            disabled
                            className="flex-1 bg-gray-700 text-gray-400 cursor-not-allowed"
                          >
                            Coming Soon
                          </Button>
                        ) : (
                          <>
                            <Button 
                              onClick={() => product.path && navigate(product.path)}
                              className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold"
                            >
                              {product.category === 'soundtrack' ? 'Purchase' : 'View Details'}
                              <ArrowRight className="w-4 h-4 ml-2" />
                            </Button>
                            {product.streamLink && (
                              <a href={product.streamLink} target="_blank" rel="noopener noreferrer">
                                <Button variant="outline" className="border-gray-700 text-gray-300 hover:bg-gray-800">
                                  <Play className="w-4 h-4" />
                                </Button>
                              </a>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Need Something Custom?</h2>
          <p className="text-gray-400 mb-8 max-w-xl mx-auto">
            We offer custom solutions for corporate licensing, bulk orders, and enterprise needs.
          </p>
          <Button 
            onClick={() => navigate('/start-project')}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-3"
          >
            Start a Project
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default StorePage;
